import { AlterableHeader } from '@/coreDomainsModule/entities/inputExcelInfo';
import { isRequireAlterableHeader } from './interfaces/LinkingInput';
import { i18n } from '@/i18n';
import { assertNever } from '@/coreDomainsModule/assertNever';

/**
 * RegisterInputのViewModel
 */
export class RegisterInputViewModel {
  private t = i18n.t;
  /**
   * 読み替え項目のヘッダー表示
   * @param header - ヘッダー
   */
  public displayHeaderTitle(header: AlterableHeader): string {
    switch (header) {
      case 'WarehouseNumber':
        return this.addRequiredMark('WarehouseNumber', this.t('置場コード'));
      case 'Warehouse':
        return this.addRequiredMark('Warehouse', this.t('置場名'));
      case 'SupplierNumber':
        return this.addRequiredMark('SupplierNumber', this.t('仕入先コード'));
      case 'SupplierName':
        return this.addRequiredMark('SupplierName', this.t('仕入先名'));
      case 'BusinessNumber':
        return this.addRequiredMark('BusinessNumber', this.t('商品コード'));
      case 'BusinessName':
        return this.addRequiredMark('BusinessName', this.t('商品名'));
      case 'Package':
        return this.addRequiredMark('Package', this.t('容量'));
      case 'CustomerNumber':
        return this.addRequiredMark('CustomerNumber', this.t('売上先コード'));
      case 'CustomerName':
        return this.addRequiredMark('CustomerName', this.t('売上先名'));
      case 'SalesDestinationNumber':
        return this.addRequiredMark('SalesDestinationNumber', this.t('送り先コード'));
      case 'SalesDestinationName':
        return this.addRequiredMark('SalesDestinationName', this.t('送り先名'));
      case 'InventoryValue':
        return this.addRequiredMark('InventoryValue', this.t('在庫数量'));
      case 'SalesResultsValue':
        return this.addRequiredMark('SalesResultsValue', this.t('販売実績数量'));
      case 'ArrivalValue':
        return this.addRequiredMark('ArrivalValue', this.t('入荷実績数量'));
      case 'Manufacturer':
        return this.addRequiredMark('Manufacturer', this.t('製造社'));
      case 'EndUser':
        return this.addRequiredMark('EndUser', this.t('エンドユーザー'));
      case 'OrderNumber':
        return this.addRequiredMark(header, this.t('発注番号'));
      case 'OrderIssuedNumber':
        return this.addRequiredMark(header, this.t('発注管理番号'));
      case 'CreatedOrderDate':
        return this.addRequiredMark(header, this.t('発注作成日'));
      case 'EstimatedTimeOfArrival':
        return this.addRequiredMark(header, this.t('納期'));
      case 'OrderAmount':
        return this.addRequiredMark(header, this.t('発注数量'));
      default:
        assertNever(header);
        return ''; // ここには来ない
    }
  }
  /**
   * 読み替え項目のヘッダー表示（必須マーク付き）
   * @param header - ヘッダー名
   * @param value - ヘッダー表示
   * @returns - ヘッダー表示
   */
  private addRequiredMark(header: AlterableHeader, value: string): string {
    return isRequireAlterableHeader(header) ? `${value} *` : value;
  }
}
